import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import ChecklistPrevioForm from './forms/ChecklistPrevioForm';
import ParteTrabajoForm from './forms/ParteTrabajoForm';
import ChecklistFinalForm from './forms/ChecklistFinalForm';
import SignaturePad from 'signature_pad';

function getServicios() {
  try { return JSON.parse(localStorage.getItem('servicios_activos') || '[]'); }
  catch { return []; }
}

function saveServicios(s) {
  localStorage.setItem('servicios_activos', JSON.stringify(s));
}

function ModalFirma({ onConfirmar, onCancelar }) {
  const canvasRef = useRef(null);
  const padRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      padRef.current = new SignaturePad(canvasRef.current, {
        backgroundColor: 'rgb(255,255,255)',
        penColor: 'rgb(0,0,0)'
      });
      const resize = () => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);
        padRef.current.clear();
      };
      resize();
    }
  }, []);

  const limpiar = () => padRef.current?.clear();

  const confirmar = () => {
    if (padRef.current?.isEmpty()) {
      alert('Por favor firma antes de continuar');
      return;
    }
    const firmaDataUrl = padRef.current.toDataURL('image/png');
    onConfirmar(firmaDataUrl);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 300 }}>
      <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', padding: 24, width: '100%', maxWidth: 600 }}>
        <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>Firma del trabajador</h3>
        <p style={{ fontSize: 12, color: '#888', marginBottom: 16 }}>Firma en el recuadro para confirmar el parte</p>
        <div style={{ border: '2px solid #e5e5e5', borderRadius: 10, overflow: 'hidden', marginBottom: 16, background: '#fff', touchAction: 'none' }}>
          <canvas ref={canvasRef} style={{ width: '100%', height: 180, display: 'block', touchAction: 'none' }} />
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={onCancelar} style={{ flex: 1, padding: '12px', borderRadius: 10, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 14 }}>
            Cancelar
          </button>
          <button onClick={limpiar} style={{ padding: '12px 20px', borderRadius: 10, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 14 }}>
            Borrar
          </button>
          <button onClick={confirmar} style={{ flex: 1, padding: '12px', borderRadius: 10, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
            Confirmar y enviar
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Servicio() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [servicio, setServicio] = useState(null);
  const [paso, setPaso] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [mostrarFirma, setMostrarFirma] = useState(false);

  useEffect(() => {
    const servicios = getServicios();
    const s = servicios.find(s => s.id === parseInt(id));
    if (!s) { navigate('/maquinista/nuevo-servicio'); return; }
    setServicio(s);
  }, [id, navigate]);

  const updateServicio = (campo, datos) => {
    const servicios = getServicios();
    const idx = servicios.findIndex(s => s.id === parseInt(id));
    if (idx === -1) return;
    servicios[idx][campo] = datos;
    saveServicios(servicios);
    setServicio({ ...servicios[idx] });
  };

  const enviarConFirma = async (firmaDataUrl) => {
    setMostrarFirma(false);
    setEnviando(true);
    try {
      const cp = servicio.checklist_previo;
      const cf = servicio.checklist_final;
      const pt = servicio.parte_trabajo;

      await api.post('/servicios/checklist-previo', {
        locomotora_id: servicio.loco_id,
        fecha: new Date(cp.fecha || servicio.fecha).toISOString(),
        hora: cp.hora,
        fugas_ext: cp.fugas_ext, sueltas_ext: cp.sueltas_ext, danos_ext: cp.danos_ext,
        mangueras_ext: cp.mangueras_ext, organos_ext: cp.organos_ext, acople_ext: cp.acople_ext,
        guarniciones_ext: cp.guarniciones_ext, grifo_ext: cp.grifo_ext, arena_ext: cp.arena_ext,
        layover_ext: cp.layover_ext, disyuntores_ext: cp.disyuntores_ext, combustible_ext: cp.combustible_ext,
        fugas_int: cp.fugas_int, aceite_int: cp.aceite_int, mangueras_int: cp.mangueras_int,
        agua_int: cp.agua_int, urea_int: cp.urea_int, parabrisas_int: cp.parabrisas_int,
        diesel_int: cp.diesel_int, abb_int: cp.abb_int, calentador_int: cp.calentador_int,
        operacion_int: cp.operacion_int, normal_int: cp.normal_int, sellado_int: cp.sellado_int,
        z4_int: cp.z4_int, regimen_int: cp.regimen_int, aislamiento_int: cp.aislamiento_int,
        caja_int: cp.caja_int, cabina_int: cp.cabina_int, observaciones: cp.observaciones
      });

      await api.post('/servicios/', {
        locomotora_id: servicio.loco_id,
        fecha: new Date(cp.fecha || servicio.fecha).toISOString(),
        base_mto: cp.base_mto,
        km_inicio: cp.km_inicio,
        km_fin: cf.km_fin,
        litros_combustible_inicio: cp.litros_combustible_inicio,
        litros_combustible_fin: cf.litros_combustible_fin,
        toneladas_combustible: cf.toneladas_combustible,
        horas_motor: cf.horas_motor,
        observaciones: pt.observaciones,
        descripcion: pt.descripcion,
        firma_trabajador: firmaDataUrl,
        tramos: pt.tramos || [],
        checklist_final: {
          hora: cf.hora,
          estacionamiento: cf.estacionamiento, parking: cf.parking, visual: cf.visual,
          lubricante: cf.lubricante, sueltas: cf.sueltas, mando: cf.mando,
          acopla: cf.acopla, combus: cf.combus, horas_motor_check: cf.horas_motor_check,
          choque: cf.choque, observaciones: cf.observaciones
        }
      });

      if (cf.litros_adblue_fin || cp.litros_adblue_inicio) {
        const litrosFin = cf.litros_adblue_fin || cp.litros_adblue_inicio;
        if (litrosFin) {
          await api.post('/adblue/', {
            locomotora_id: servicio.loco_id,
            fecha: new Date().toISOString(),
            km: cf.km_fin || cp.km_inicio,
            litros: litrosFin,
            es_repostaje: false,
            es_correccion: true,
            notas: 'Actualizado desde parte del maquinista'
          });
        }
      }

      const servicios = getServicios();
      const idx = servicios.findIndex(s => s.id === parseInt(id));
      servicios[idx].enviado = true;
      saveServicios(servicios);
      navigate('/maquinista/nuevo-servicio');
    } catch (e) {
      alert('Error al enviar. Intentalo de nuevo.');
      console.error(e);
    } finally {
      setEnviando(false);
    }
  };

  if (!servicio) return <div style={{ padding: 40, color: '#888' }}>Cargando...</div>;

  const pasos = [
    { key: 'checklist_previo', label: 'Checklist inicio' },
    { key: 'parte_trabajo', label: 'Parte de trabajo' },
    { key: 'checklist_final', label: 'Checklist final' },
  ];
  const completados = pasos.filter(p => servicio[p.key]).length;

  if (paso === 'checklist_previo') return (
    <ChecklistPrevioForm
      locoId={servicio.loco_id}
      inicial={servicio.checklist_previo}
      onGuardar={datos => { updateServicio('checklist_previo', datos); setPaso(null); }}
      onVolver={() => setPaso(null)}
    />
  );

  if (paso === 'parte_trabajo') return (
    <ParteTrabajoForm
      locoId={servicio.loco_id}
      inicial={servicio.parte_trabajo}
      kmInicio={servicio.checklist_previo?.km_inicio}
      onGuardar={datos => { updateServicio('parte_trabajo', datos); setPaso(null); }}
      onVolver={() => setPaso(null)}
    />
  );

  if (paso === 'checklist_final') return (
    <ChecklistFinalForm
      inicial={servicio.checklist_final}
      kmInicio={servicio.checklist_previo?.km_inicio}
      onGuardar={datos => { updateServicio('checklist_final', datos); setPaso(null); }}
      onVolver={() => setPaso(null)}
    />
  );

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '20px 16px', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <button onClick={() => navigate('/maquinista/nuevo-servicio')} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 14 }}>
          ← Volver
        </button>
        <div>
          <h1 style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>🚂 {servicio.loco_numero}</h1>
          <p style={{ fontSize: 12, color: '#888', margin: '2px 0 0' }}>{servicio.fecha} · {completados}/3 completados</p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 24 }}>
        {pasos.map(p => (
          <div key={p.key} style={{ flex: 1, height: 4, borderRadius: 2, background: servicio[p.key] ? '#3b6d11' : '#f0f0f0' }} />
        ))}
      </div>

      <div style={{ display: 'grid', gap: 12, marginBottom: 24 }}>
        {pasos.map((p, i) => {
          const completado = !!servicio[p.key];
          const bloqueado = i > 0 && !servicio[pasos[i - 1].key];
          return (
            <button key={p.key} onClick={() => !bloqueado && setPaso(p.key)}
              disabled={bloqueado}
              style={{
                padding: '20px', borderRadius: 14,
                border: `2px solid ${completado ? '#97c459' : bloqueado ? '#f0f0f0' : '#e5e5e5'}`,
                background: completado ? '#eaf3de' : bloqueado ? '#f8f8f8' : '#fff',
                cursor: bloqueado ? 'not-allowed' : 'pointer', textAlign: 'left', width: '100%',
                display: 'flex', alignItems: 'center', gap: 16
              }}>
              <div style={{
                width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
                background: completado ? '#3b6d11' : bloqueado ? '#ddd' : '#f0f0f0',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: completado ? 18 : 14, color: completado ? '#fff' : '#888'
              }}>
                {completado ? '✓' : i + 1}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 600, color: bloqueado ? '#aaa' : '#1a1a1a' }}>{p.label}</div>
                <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                  {completado ? 'Completado — pulsa para editar' : bloqueado ? 'Completa el paso anterior primero' : 'Pendiente — pulsa para rellenar'}
                </div>
              </div>
              {!bloqueado && <div style={{ fontSize: 18, color: '#aaa' }}>›</div>}
            </button>
          );
        })}
      </div>

      {completados === 3 && (
        <button onClick={() => setMostrarFirma(true)} disabled={enviando} style={{
          width: '100%', padding: '18px', borderRadius: 14, border: 'none',
          background: enviando ? '#ccc' : '#1a1a1a', color: '#fff',
          fontSize: 16, fontWeight: 700, cursor: enviando ? 'not-allowed' : 'pointer'
        }}>
          {enviando ? 'Enviando...' : 'Firmar y enviar ✓'}
        </button>
      )}

      {mostrarFirma && (
        <ModalFirma
          onConfirmar={enviarConFirma}
          onCancelar={() => setMostrarFirma(false)}
        />
      )}
    </div>
  );
}
